import { IAuction } from 'src/_models/auction.model'
import { differenceInDays } from 'date-fns'

export const isPastAuction = (auction: IAuction) => {
  const days = differenceInDays(auction.auctionEndDate, new Date())
  const auctionNoLongerLive = auction.auctionStatus === 'CANCELLED' || auction.auctionStatus === 'ENDED'
  return days < 0 || auctionNoLongerLive
}
